export default __webpack_public_path__ + "static/media/closed_sign.5b3ba36c.jpg";